<ng-container *ngIf="translations.length > 1; else noTranslations">
  <lms-toolbar *ngIf="!selectedTranslations || selectedTranslations.length === 0">
    <div left>
      <div class="list-counter">
        <span>{{ 'itineraries.headerTable.numLangs' | translate }}: {{ translations.length }}</span>
      </div>
    </div>

    <gl-button
      color-primary
      title="{{ (isAllTranslated ? null : 'actions.addLanguage') | translate }}"
      [text]="'actions.addLanguage' | translate"
      [disabled]="isAllTranslated"
      (onClick)="selectTranslation()"
    >
    </gl-button>
  </lms-toolbar>

  <div class="gl-table__container">
    <div
      class="lms-toolbar__secondary"
      [ngClass]="{ hidden: !selectedTranslations || selectedTranslations.length === 0 }"
    >
      <div class="table-counter">
        <span>{{ 'itineraries.headerTable.selectedLangs' | translate }}: {{ selectedTranslations?.length }}</span>
      </div>
      <div>
        <a (click)="deleteLang()" title="{{ 'actions.delete' | translate }}">
          {{ 'actions.delete' | translate }}
        </a>
        <a (click)="cancelSelection()" title="{{ 'actions.cancel' | translate }}">
          {{ 'actions.cancel' | translate }}
        </a>
      </div>
    </div>

    <gl-table
      [id]="listId"
      #translationsTable
      [dataSource]="dataSource"
      data-testid="itineraryTranslationsTable"
      [placeholder]="'actions.noResultTable' | translate"
      selectable
      (onClickRow)="selectTranslation($event.detail.data.lang)"
      (onSelectionChanged)="onSelectionChanged($event.detail.selected)"
    >
    </gl-table>
  </div>
</ng-container>

<ng-template #noTranslations>
  <no-itinerary-translations (createTranslation)="selectTranslation()"></no-itinerary-translations>
</ng-template>

<lms-modal #modalLangDelete size="small">
  <div class="gl-popup__title">{{ 'itineraries.notification.titleDeleteLang' | translate }}</div>
  <div class="gl-popup__close" (click)="modalLangDelete.close()">
    <span class="glicon-close"></span>
  </div>
  <div class="gl-popup__text" [innerHTML]="deleteMessage"></div>
  <div class="gl-popup__text">{{ 'itineraries.notification.undoActionMessage' | translate }}</div>
  <div class="gl-popup__buttons">
    <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="modalLangDelete.close()"> </gl-button>
    <gl-button color-primary [text]="'actions.delete' | translate" (onClick)="confirmDelete()"> </gl-button>
  </div>
</lms-modal>
